import React, { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import Table from '../../../../components/table';
import { useAuth } from '../../../../contexts/auth';
import CategoryDriver, {
  CategoryDriverText
} from '../../../../models/enums/categoryDriver';
import tariffDynamicService from '../../../../services/tariffDynamicService';
import { DynamicType, DynamicTypeText } from '../../../../models/enums/dinamicType';
import { StatusType, StatusTypeText } from '../../../../models/enums/statusType';
import {
  getDocs, orderBy, query, tariffDynamicCollection, where
} from '../../../../config/firebase';
import { usePagination } from './usePaginationList';
import { toBrazilDateTime } from '../../../../components/mask';

export default function index() {
  const history = useHistory();
  const { subsidiaryId } = useAuth();
  const [total, setTotal] = React.useState(0);
  const [enableSearch, setEnableSearch] = React.useState<boolean>(false);
  const [items, setItems] = React.useState<any>([]);

  const queryParams = subsidiaryId === undefined
    ? query(tariffDynamicCollection, orderBy('subsidiary', 'asc'))
    : query(tariffDynamicCollection, orderBy('subsidiary', 'asc'), where('subsidiary', '==', subsidiaryId));

  const {
    items: itemsPag,
    isLoading,
    getPrev,
    getNext,
    current,
    currentTotal,
    isStart,
    isEnd
  } = usePagination(
    queryParams,
    {
      limit: 10
    }
  );

  useEffect(() => {
    getTotal();
  }, []);

  const getTotal = async () => {
    await tariffDynamicService.getAllCount(subsidiaryId).then((item: any) => {
      setTotal(item.total);
    });
  };

  const searchItem = useCallback(async (params: string) => {
    const queryParamsSearch = subsidiaryId === undefined
      ? query(tariffDynamicCollection, where('description', '==', params))
      : query(tariffDynamicCollection, where('subsidiary', '==', subsidiaryId), where('description', '==', params));
    const q = queryParamsSearch;
    const snapshot = await getDocs(q);

    const results = snapshot?.docs.map((snap) => {
      const {
        description, categoryDriver, type, value, activated, activateUntil
      } = snap.data();

      return {
        id: snap.id,
        description,
        categoryDriver,
        type,
        value:
          type === 1
            ? `${value}X`
            : value.toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL'
            }),
        activated,
        activateUntil:
          activated === 1 || activated === 0
            ? ' - '
            : toBrazilDateTime(activateUntil.toDate())
      };
    });

    setEnableSearch(true);
    setItems(results);
    setTotal(results.length);
  }, []);

  const tableChange = useCallback((action: string, state: any) => {
    if (action === 'search') {
      if (state.searchText !== null) {
        searchItem(state.searchText);
      }
    }

    if (action === 'onSearchClose') {
      setEnableSearch(false);
      setItems([]);
      getTotal();
    }

    if (action === 'filterChange') {
      // getFilter(state.filterList);
    }
  }, []);

  const columns = [
    {
      name: 'id',
      label: 'ID',
      options: {
        filter: false,
        sort: false,
        display: false
      }
    },
    {
      name: 'description',
      label: 'Descrição',
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: 'categoryDriver',
      label: 'Categoria',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: CategoryDriver) => CategoryDriverText[value]
      }
    },
    {
      name: 'type',
      label: 'Tipo',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: DynamicType) => DynamicTypeText[value]
      }
    },
    {
      name: 'value',
      label: 'Valor',
      options: {
        filter: true,
        sort: true
      }
    },
    {
      name: 'activated',
      label: 'Status',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: StatusType) => StatusTypeText[value]
      }
    },
    {
      name: 'activateUntil',
      label: 'Finaliza em',
      options: {
        filter: true,
        sort: true
      }
    }
  ];

  const onRowClick = (rowData: string[]) => {
    const id = rowData[0];
    if (id) {
      history.push(`/settings/tariffs-dynamic/${id}/edit`);
    }
  };

  return (
    <Table
      title="Tarifas Dinâmicas"
      data={enableSearch ? items : itemsPag}
      columns={columns}
      filter={false}
      onRowClick={onRowClick}
      createUrl="tariffs-dynamic/create"
      onTableChange={tableChange}
      serverSide
      count={total}
      pagination={false}
      isLoading={isLoading}
      getPrev={getPrev}
      getNext={getNext}
      current={current}
      currentTotal={currentTotal}
      isStart={isStart}
      isEnd={isEnd}
      enableSearch={enableSearch}
    />
  );
}
